import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

// project overviews
import projects from './projects';

// text and pictures on a given topic
import articles from './stories';

// this are basically just problem/answer statements
// that can be linked to projects and stories
import problems from './problems';
import services from './services';

const currentDate = new Date().toISOString();

export default new Vuex.Store({
  state: {
    gaid: 'UA-119442697-1',
    messages: [
      { id: 1, message: 'We free your data from Excel spreadsheets' },
      { id: 2, message: 'We put more science in "data science"' },
      { id: 3, message: 'We can build a button for that' },
      { id: 4, message: 'We de-jargon science communication' },
    ],
    problems,
    services,
    projects,
    articles,
  },
  getters: {
    currentDate(){
      return currentDate;
    },
    activeProjects: state => {
      return state.projects
        .filter( d => d.active && d.date <= currentDate)
        .sort((a,b) => a.date < b.date ? 1 : -1);
    },
    activeNews: state => {
      return state.articles
        .filter( d => d.active && d.date <= currentDate)
        .sort((a,b) => a.date < b.date ? 1 : -1);
    }
  },
  mutations: {

  },
  actions: {
    pageView({ state }, page_path){
      gtag('config', state.gaid, { page_path });
    },
    pageEvent({ state }, { label }){
      gtag('event', 'generate_lead', {
        event_label: label,
      });
    }
  }
})
